import React from "react";

const SvgSearch = props => (
  <svg width={23} height={24} viewBox="0 0 23 24" {...props}>
    <path fill={props.fill === undefined ? 'currentColor' : props.fill} d="M14.481 16.139a9 9 0 111.11-1.01l6.66 7.265a.75.75 0 11-1.106 1.014l-6.664-7.27zM9 16.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15z" />
  </svg>
);

export default SvgSearch;
